module.exports = __webpack_public_path__ + "static/img/kurogokiy.c26b922.jpg";